import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import ActionStatusLabel from "../../../Common/Label/ActionStatusLabel";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function AuctionList({ listing, update, deleteee }) {
  const path = "Assets/scss/FindWork.module.scss";
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div>
      <div className="row auction-row">
        {Array.isArray(listing) &&
          listing.map((item, index) => {

            const showEdit = item.status == 1 && item.bid_count == 0;
            const showDelete = item.status == 3 || (item.status == 1 && item.bid_count == 0);

            return (
              <div className="col-md-4" key={index}>
                <div className="auction-det">
                  <div className="auction-img w-100">
                    <DisplayFileProper item={{ file: (Array.isArray(item?.files) && item?.files[0]?.file) }} className="w-100" />
                    {(showEdit || showDelete) && (
                      <div className="add-button-education">
                        {showDelete && (
                          <button onClick={() => setSelectedId(item?.id)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/delete-icon.svg`}
                              alt="delete"
                            />
                          </button>
                        )}
                        {showEdit && (
                          <button onClick={() => update(item?.id)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                              alt="edit"
                            />
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  <h4>{item?.title}</h4>
                  <div className="minimum-bid">
                    <div>
                      <p>Minimum bid</p>
                      <h6>$ {Commas(item?.min_bid)}</h6>
                    </div>
                    <div>
                      <h5>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/hand-tick.svg`}
                          alt=""
                        />
                        {item?.bid_count || 0}
                      </h5>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center bid-flex">
                    <p>
                      Bid type : <span>{item?.auction_type == 2 ? 'Incremental' : 'Sealed'}</span>
                    </p>
                    {item?.max_bid !== 0 && (
                      <p>
                        Highest bid : <h6>$ {Commas(item?.max_bid)}</h6>
                      </p>
                    )}
                  </div>

                  {item.auction_type == "2" ? (
                    <p className="end-in my-3 justify-content-center" >
                      <span style={{ color: '#08af22' }}>Incremental</span>
                    </p>
                  ) : (
                    <p className="end-in my-3 justify-content-center" style={{ background: "#FFF2E7", color: '#EF7710' }}>
                      <span>Sealed</span>
                    </p>
                  )}

                  <ActionStatusLabel item={item} />
                </div>
                <ConfirmModal
                  isOpen={selectedId == item?.id}
                  toggle={() => setSelectedId(null)}
                  title="Confirm Delete"
                  message="Do you want to delete this item?"
                  onConfirm={() => {
                    deleteee(item?.id);
                    setSelectedId(null);
                  }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}
